
export function getCurrentUser() {
    // return authorization header with jwt token
    return JSON.parse(localStorage.getItem('currentUser'));
}